import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { borderRadius, colors, spacing, strokeWidth, typography } = themeVariables;

/**
 * The card's elevation.
 *
 * The theme has no shadow token, so the geometry the design states is stated here and
 * only the color stays a theme decision, the same trade `ProductCard` makes. The design
 * specifies #0E0E11 where this uses the brand black: imperceptible at 10%.
 */
export const ELEVATION = `0 0 2px 0 color-mix(in srgb, var(${colors.content.default}) 10%, transparent)`;

/* The container the photo carousel measures itself against, so the photo's cap follows
   the card's own width and not the viewport's: the same card sits in a full-screen drawer
   on a phone and a side panel on a desktop. */
export const card = css`
  container-type: inline-size;
  display: flex;
  flex-direction: column;
  gap: var(${spacing.md});
  padding: var(${spacing.md});
  border: var(${strokeWidth}) solid var(${colors.stroke.default});
  border-radius: var(${borderRadius.md.mobile});
  background-color: var(${colors.surface.default});
  box-shadow: ${ELEVATION};
`;

export const ratingRow = css`
  display: flex;
  align-items: center;
  gap: var(${spacing.sm});
`;

export const date = css`
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.sm.fontSize});
  line-height: var(${typography.body.sizes.sm.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
  color: var(${colors.content.secondary});
  white-space: nowrap;
`;

export const content = css`
  display: flex;
  flex-direction: column;
  gap: var(${spacing.sm});
`;

/* No clamp and no reserved height: this card is as tall as the review is long, which is
   the whole difference between it and the preview. `overflow-wrap` because a review can
   be a single unbroken token, a pasted URL for instance. */
export const text = css`
  margin: 0;
  overflow-wrap: anywhere;
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
  color: var(${colors.content.default});
`;
